var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatmaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73936 8.3534C10.1903 6.9027 10.4325 4.70011 9.46584 2.99855C12.2084 3.50599 14.2864 5.91059 14.2864 8.79998C14.2864 10.5815 14.0518 12.3093 13.6183 13.9597L13.3722 14.8969L14.2786 14.5544C15.9134 13.9368 17.166 12.5361 17.5696 10.8064C18.2807 11.8248 18.6969 13.0632 18.6969 14.3999C18.6969 18.1004 15.6987 21.0999 11.9969 21.0999C8.29692 21.0999 5.29688 18.1003 5.29688 14.3999C5.29688 12.661 5.99963 11.0902 7.13865 9.95387L7.13904 9.95348L8.73936 8.3534Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmaster);
export default __webpack_public_path__ + "static/media/heatmaster.88990a5aa40668bc57878bd2c34b4299.svg";
export { ForwardRef as ReactComponent };